export const FT_DEBUG_PARAMETER = 'flipto-debug';
export const FT_PREVIEW_PARAMETER = 'flipto-preview';
export const FT_PREVIEW_START_PARAMETER = 'flipto-preview-start';
export const DEBUG_PARAMETER = 'debug';

